import { forwardRef } from 'react';
import { FormControl } from '../FormControl/FormControl';
import { Checkbox } from './Checkbox';
export const CheckboxField = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function CheckboxField({
  label,
  labelStyle,
  helperText,
  helperStyle,
  error,
  outerStyle,
  innerStyle,
  children,
  ...other
}, forwardedRef) {
  return <FormControl label={label} labelStyle={labelStyle} helperText={helperText} helperStyle={helperStyle} error={error} outerStyle={outerStyle}>
				<label css={innerStyle}>
					<Checkbox {...other} ref={forwardedRef} />
					{children}
				</label>
			</FormControl>;
});